import { status } from "skin/event/status";


const screen = (obj, form, story, data, d ,action) => {
    story.current.info = 'android';
    return status.action;
}

export default screen;